// @ts-nocheck
import { useDispatch, useSelector } from 'react-redux';
import { enqueueSnackbar } from 'notistack';
import { RootState } from '../store/store';
import { useGetUserInfoMutation } from '../pages/settings/services/user';
import { setCurrentUserState } from '../store/slices/currentUserState';

export const useRefreshCurrentUser = () => {
  const dispatch = useDispatch();
  const { currentUserState } = useSelector((state: RootState) => state.currentUserState);
  const [getUserInfo] = useGetUserInfoMutation();

  const refreshCurrentUserPreserveSelection = async () => {
    try {
      // Mevcut localStorage.currentUser içinden daha önce hangi kurumun seçili olduğunu bul
      const previousRaw = localStorage.getItem('currentUser');
      const previousList: any[] = previousRaw ? JSON.parse(previousRaw) : [];

      // Öncelik: selectedUserInfo === 1 olan kayıt
      const previousSelectedByFlag = previousList.find((u: any) => u.selectedUserInfo === 1) || null;
      // Eğer flag yoksa, Redux'taki currentUserState.companyId ile eşleşen kaydı kullan
      const previousSelectedByCompanyId =
        !previousSelectedByFlag && currentUserState?.companyId
          ? previousList.find((u: any) => u.companyId === currentUserState.companyId)
          : null;

      const previousSelected = previousSelectedByFlag || previousSelectedByCompanyId || null;
      const previousSelectedCompanyId = previousSelected?.companyId;

      // Backend'den güncel kullanıcı listesi (email vb. taze veri) çek
      const result: any = await getUserInfo();
      const newList: any[] = Array.isArray(result?.data) ? result.data : [];

      if (!newList.length) {
        return;
      }

      // Gelen listedeki tüm kayıtları normalize et, selectedUserInfo yoksa 0 kabul et
      let merged = newList.map((item) => ({
        ...item,
        selectedUserInfo: typeof item.selectedUserInfo === 'number' ? item.selectedUserInfo : 0,
      }));

      // Tek bir kaydı seçili yapmak için yardımcı fonksiyon
      const applySingleSelection = (index: number) => {
        merged = merged.map((u, i) => ({
          ...u,
          selectedUserInfo: i === index ? 1 : 0,
        }));
      };

      // 1) Eski seçili companyId hâlâ listede varsa, o kaydı yeniden seç
      if (previousSelectedCompanyId) {
        const idx = merged.findIndex((u: any) => u.companyId === previousSelectedCompanyId);
        if (idx !== -1) {
          applySingleSelection(idx);
        } else {
          // 2) Eski companyId yoksa, backend zaten bir seçili kayıt verdiyse ona dokunma
          const existingIdx = merged.findIndex((u: any) => u.selectedUserInfo === 1);
          if (existingIdx === -1) {
            // 3) Hiç seçili yoksa, güvenli fallback: ilk kaydı seç
            applySingleSelection(0);
          }
        }
      } else {
        // Önceden seçili companyId bilinmiyorsa mevcut seçimi koru, yoksa ilk kaydı seç
        const existingIdx = merged.findIndex((u: any) => u.selectedUserInfo === 1);
        if (existingIdx === -1) {
          applySingleSelection(0);
        }
      }

      // Kalıcı olsun diye tüm listeyi localStorage.currentUser içine yaz
      localStorage.setItem('currentUser', JSON.stringify(merged));

      // Header ve diğer yerler için Redux'taki currentUserState'i de güncelle
      const selectedUser = merged.find((u: any) => u.selectedUserInfo === 1) || merged[0];
      if (selectedUser) {
        dispatch(setCurrentUserState(selectedUser));
      }
    } catch (error) {
      console.error('Profil bilgileri güncellenirken bir hata oluştu.',error);
    }
  };

  return { refreshCurrentUserPreserveSelection };
};

